import { bsConstants } from '../../module.constants'

export type PasswordLengthErrorKey = 'minPasswordLength' | 'maxPasswordLength'

/** Uses `bsConstants.USER.PASSWORDS`; aligned with user auth DTO validation. */
export function getPasswordLengthErrorKey (password: string): PasswordLengthErrorKey | null {
  const { MIN_LENGTH, MAX_LENGTH } = bsConstants.USER.PASSWORDS
  if (password.length < MIN_LENGTH) return 'minPasswordLength'
  if (password.length > MAX_LENGTH) return 'maxPasswordLength'
  return null
}
